export default "__VITE_ASSET__COVDX7Qt__"